import React from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Box,
  Text,
  VStack,
  Button,
} from "@chakra-ui/react";

/**
 * Modal para seleccionar un pase de entrada cuando hay múltiples candidatos
 * para vincular al pase de salida.
 */
export const ModalSelectEntryPass = ({
  isOpen,
  onClose,
  candidates = [],
  onSelect,
}) => {
  const handleSelect = (candidate) => {
    onSelect(candidate?.id);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Seleccione el pase de entrada a vincular
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={4} color="gray.600" fontSize="sm">
            Existen varios pases de entrada autorizados para este vehículo.
            Seleccione el que desea vincular al pase de salida.
          </Text>
          <VStack align="stretch" spacing={2}>
            {candidates.map((candidate) => (
              <Box
                key={candidate.id}
                p={4}
                border="1px solid"
                borderColor="gray.200"
                borderRadius="md"
                cursor="pointer"
                _hover={{ bg: "blue.50", borderColor: "blue.200" }}
                onClick={() => handleSelect(candidate)}
                transition="all 0.2s"
              >
                <Text fontWeight="semibold">
                  Formulario #{candidate.passForm_number}
                </Text>
                <Text fontSize="sm" color="gray.600">
                  Placa: {candidate.vehicle_plate} | Identificación:{" "}
                  {candidate.identification}
                </Text>
                <Text fontSize="xs" color="gray.500">
                  Estado: {candidate.status_entryPass}
                </Text>
              </Box>
            ))}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};